import React, { useState } from "react";

const NotificationPage = () => {
  const [activeTab, setActiveTab] = useState("session");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Sample notifications for Session and magicAI
  const sessionNotifications = [
    { id: 1, message: "All your scheduled & instant video session related notifications will be shown here." },
  ];

  const magicAINotifications = [
    { id: 4, message: "All the updates and features will be shown here. You need to join the waitlist to receive notification." },
  ];

  return (
    <div className="p-5 lg:px-80 bg-gray-100 min-h-screen">
      {/* Tab Buttons */}
      <div className="flex justify-center  mb-4">
        <button
          className={`mr-4 px-4 py-2 rounded-lg focus:outline-none ${
            activeTab === "session" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
          onClick={() => handleTabClick("session")}
        >
          Session
        </button>
        <button
          className={`px-4 py-2 rounded-lg focus:outline-none ${
            activeTab === "magicAI" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
          onClick={() => handleTabClick("magicAI")}
        >
          MagicAI
        </button>
      </div>

      {/* Notification Sections */}
      {activeTab === "session" && (
        <section className="bg-white text-2xl p-10  rounded-lg shadow-md h-screen">
          {sessionNotifications.map((notification) => (
            <div
              key={notification.id}
              className="notification-item cursor-pointer hover:bg-gray-200 p-2 mb-2 rounded-lg"
            >
              {notification.message}
            </div>
          ))}
        </section>
      )}

      {activeTab === "magicAI" && (
        <section className="bg-white text-2xl p-10 rounded-lg shadow-md  h-screen">
          {magicAINotifications.map((notification) => (
            <div
              key={notification.id}
              className="notification-item cursor-pointer hover:bg-gray-200 p-2 mb-2 rounded-lg"
            >
              {notification.message}
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

export default NotificationPage;
